import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M15 8v8H5V8h10m1-2H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4V7c0-.55-.45-1-1-1z"
}), 'VideocamOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/VideocamOutlined.js
// module id = 7056
// module chunks = 2